import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import ErrorBoundary from './components/common/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <ErrorBoundary>
   
    </ErrorBoundary> */}
       <App />
  </React.StrictMode>
);